import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Wallet, Bitcoin, CircleDollarSign } from 'lucide-react';
import { useUser } from '../context/UserContext';
import DashboardLayout from '../components/DashboardLayout';

const WALLETS = [
  { type: 'BTC', name: 'Bitcoin', color: 'from-orange-500 to-orange-600', icon: Bitcoin },
  { type: 'ETH', name: 'Ethereum', color: 'from-purple-500 to-purple-600', icon: CircleDollarSign },
  { type: 'BCH', name: 'Bitcoin Cash', color: 'from-green-500 to-green-600', icon: CircleDollarSign },
];

export default function WalletID() {
  const navigate = useNavigate();
  const { user } = useUser();

  if (!user?.telegramName) {
    navigate('/login');
    return null;
  }

  return (
    <DashboardLayout>
      <div className="max-w-3xl mx-auto px-4 py-8">
        <button onClick={() => navigate('/dashboard')} className="flex items-center gap-2 text-slate-700 hover:text-slate-900 mb-6 transition">
          <ArrowLeft size={20} /> Back
        </button>

        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Wallet className="text-orange-600" size={28} />
          </div>
          <h1 className="text-2xl font-bold text-slate-900">Crypto Wallet</h1>
          <p className="text-slate-600 mt-2">Manage your cryptocurrency wallets</p>
        </div>

        <div className="grid gap-4">
          {WALLETS.map(w => {
            const Icon = w.icon;
            return (
              <button
                key={w.type}
                onClick={() => navigate(`/wallet/${w.type}`)}
                className={`p-6 bg-gradient-to-r ${w.color} text-white rounded-2xl shadow-lg hover:shadow-xl transition-all flex items-center justify-between group`}
              >
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                    <Icon size={24} />
                  </div>
                  <div className="text-left">
                    <p className="text-3xl font-bold mb-1">{w.type}</p>
                    <p className="text-white/90">{w.name}</p>
                  </div>
                </div>
                <ArrowLeft size={24} className="rotate-180 group-hover:translate-x-1 transition-transform" />
              </button>
            );
          })}
        </div>
      </div>
    </DashboardLayout>
  );
}
